import type { ExtractionAiField } from '~/features/dynamic-data-extraction/types/ExtractionAiField';
import type { ExtractionAiFieldCells } from '~/features/dynamic-data-extraction/types/ExtractionAiFieldCell';

import { parseAiFieldCellKey } from './aiFieldCellKey';

export const pruneOrphanedAiFieldCells = (
  aiFieldCells: ExtractionAiFieldCells,
  aiFields: ExtractionAiField[],
): ExtractionAiFieldCells => {
  const validFieldIds = new Set(aiFields.map((field) => field.id));

  return Object.fromEntries(
    Object.entries(aiFieldCells).filter(([cellKey]) => {
      const { fieldId } = parseAiFieldCellKey(cellKey);
      return validFieldIds.has(fieldId);
    }),
  );
};
